import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgFocus = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M12.681 1.408c6.075 0 11 4.925 11 11s-4.925 11-11 11h.02-.041c-6.065-.012-10.979-4.932-10.979-11 0-6.075 4.925-11 11-11Zm1.045 2.15v2.38a1.045 1.045 0 0 1-2.077.169l-.013-.17V3.56a8.913 8.913 0 0 0-7.804 7.804H6.21a1.045 1.045 0 0 1 .17 2.076l-.17.014H3.832a8.913 8.913 0 0 0 7.804 7.804v-2.379a1.045 1.045 0 0 1 2.077-.17l.013.17v2.379a8.913 8.913 0 0 0 7.804-7.804h-2.876a1.045 1.045 0 0 1-.17-2.077l.17-.014h2.876a8.913 8.913 0 0 0-7.804-7.803Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgFocus)
const Memo = memo(ForwardRef)
export default Memo
